import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {DashboardHomePage} from "../dashboard-home/dashboard-home";
import {ServiceProvider} from "../../providers/service/service";

/**
 * Generated class for the DailyCallLogsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-daily-call-logs',
  templateUrl: 'daily-call-logs.html',
})
export class DailyCallLogsPage {

  callLogs:any;

  constructor(public navCtrl: NavController, public navParams: NavParams,public service:ServiceProvider,public loadingCtrl:LoadingController)
  {
    this.getLogs();

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DailyCallLogsPage');
  }


  getLogs()
  {
    let loading=this.loadingCtrl.create({
      content:"Loading Call Logs..."
    });

    loading.present();

    setTimeout(()=>{
      loading.dismiss();
    },10000)

    this.service.httppostcall("web_service/get_daily_call_logs","").subscribe(data=>{

      this.callLogs=data;
      loading.dismiss();

    });
  }

  dismiss()
  {

    this.navCtrl.setRoot(DashboardHomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/daily-call-logs/daily-call-logs.ts